export const filters = {};

export function registerFilters(Vue) {
    for (var name in filters) {
      // console.log('register:', name);
      Vue.filter(name, filters[name]);
      
    }
}

export default filters;